import React from "react";
import { bool, node, oneOf, string } from "prop-types";
import { Col, Container, Row } from "../../../Grid";

const ContentContainer = ({
	mx = false,
	px = false,
	my = false,
	py = false,
	sm = "",
	md = "",
	lg = "",
	center = false,
	containerClassName = "",
	className = "",
	isFluid = false,
	children,
}) => {
	return (
		<Container className={containerClassName} isFluid={isFluid}>
			<Row mx={mx} px={px} my={my} py={py} className={className} center={center}>
				<Col sm={sm} md={md} lg={lg}>
					{children}
				</Col>
			</Row>
		</Container>
	);
};

ContentContainer.propTypes = {
	mx: bool,
	px: bool,
	my: bool,
	py: bool,
	sm: oneOf(["", "auto", "shrink", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	md: oneOf(["", "auto", "shrink", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	lg: oneOf(["", "auto", "shrink", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	center: bool,
	containerClassName: string,
	className: string,
	isFluid: bool,
	children: node.isRequired,
};

export default ContentContainer;
